import { composeCommonInputValues } from "./marketoUtil";
import { commonInterface, utmInterface } from "./marketoFields";
import { app, PRODUCTION } from "../../../../../config/env";
import { utm, getCookie } from "../../../utils/analytics";
import { ts, randomInt, roundNumber } from "../../../utils/other";

//  this class is to specify the fields that are required to submit to Marketo
//  if fields are different between input fields and marketo
//  pass in a function that modifies the value object to componseValueFns array
export class MkForm {
  constructor(
    formSpecificFields = [],
    excludeFields = {},
    composeValueFns = []
  ) {
    this.formSpecificFields = formSpecificFields;
    this.excludeFields = excludeFields;
    this.composeValueFns = composeValueFns;
  }

  get getFormRequiredFields() {
    return commonInterface
      .concat(utmInterface, this.formSpecificFields)
      .filter((field) => !this.excludeFields[field]);
  }

  composeMkFormValues(values) {
    //  process the form values of common fields
    const modifiedInputValues = composeCommonInputValues(values);

    let mkFormValues;

    if (
      this.formSpecificFields.length &&
      this.formSpecificFields[0]["Custom"] === true
    ) {
      mkFormValues = {};

      //  invoke fn to add additional fields for specific forms
      const modifiedValues = this.composeValueFns.reduce((acc, fn) => {
        acc = fn(acc);
        return acc;
      }, modifiedInputValues);

      mkFormValues = modifiedValues;

      this.formSpecificFields.map((field) => {
        if (
          field.value ||
          (field.name &&
            field.name.indexOf("utm") > -1 &&
            field.name.indexOf("__c") === -1) ||
          (field.name && field.name === "last_referral_url__c")
        ) {
          mkFormValues[field.name] = field.value;
        }
      });
    } else {
      //  invoke fn to add additional fields for specific forms
      const modifiedValues = this.composeValueFns.reduce((acc, fn) => {
        acc = fn(acc);
        return acc;
      }, modifiedInputValues);

      //  get the required fields of this form
      const requiredFields = this.getFormRequiredFields;

      //  create the object for mkForm
      mkFormValues = requiredFields.reduce((acc, key) => {
        acc[key] = modifiedValues[key];
        return acc;
      }, {});
    }

    //  Send A/B testing data to Marketo
    const A_B_Experiment_ID__c = localStorage.getItem("all_experiments");

    //  Partnerize
    const Partnerize_Conversion_ID_App__c = `${ts}${roundNumber(
      randomInt(1, 100)
    )}`;

    return {
      ...mkFormValues,
      ...utm(),
      ...(app.appEnv !== PRODUCTION && {
        Website_Environment__c: "Testing",
      }),
      lastReferrerURL__c: getCookie("_mkto_referrer"),
      Sync_from_SFDC_to_Marketo__c: true,
      ...(Partnerize_Conversion_ID_App__c && {
        Partnerize_Conversion_ID_App__c,
      }),
      ...(A_B_Experiment_ID__c && {
        A_B_Experiment_ID__c,
      }),
    };
  }
}
